import { render, staticRenderFns } from "./CustomMessages.vue?vue&type=template&id=c80a024c&"
import script from "./CustomMessages.vue?vue&type=script&lang=js&"
export * from "./CustomMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports